export default "__VITE_ASSET__Ddz4qf6d__"